import { ProvisionItem } from "../provisionitem";
import { ProposerExecution } from "../proposerexecution";


export class GetFPCExecutionsRequest {
    FPCFamily: string;
    PDVersion: string;
    //Provision: Array<ProvisionItem>;
    CSpec: Array<ProvisionItem>;
    VSpec: Array<ProvisionItem>;
    ProposerExecutions: Array<ProposerExecution>;
    ShowOnlyRecommended: boolean;
    Wso2: boolean;
    TimeValidity: boolean;
}


